import { Component } from '@angular/core';
import { environment } from '@app/environment';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        <span>{{ appName }}</span>
        <span class="ml-2 text-muted-color text-sm">v{{ version }}</span>
    </div>`
})
export class AppFooter {
    appName = environment.appName;
    version = environment.version;
}
